import {
  matchableString,
  payloadComputedProperty,
  SB,
  searchableComputedProperty,
} from '@play-co/replicant';
import { State } from '../State';
import { getPlayerProfileAvatarFrame } from './profile.getters';

export const profileProperties = {
  profileName: payloadComputedProperty(
    SB.string(),
    (state: State) => state.profile?.name || '',
  ),

  profilePhoto: payloadComputedProperty(
    SB.string(),
    (state: State) => state.profile?.photo || '',
  ),

  // public profile data
  hasPublicProfile: searchableComputedProperty(
    SB.boolean(),
    (state: State) => !!state.publicProfile,
  ),
  publicProfileName: payloadComputedProperty(
    SB.string(),
    (state: State) => state.publicProfile?.name || '',
  ),
  // Same as public profile name, used for searching players by name
  publicProfileNameSearchable: searchableComputedProperty(
    matchableString(),
    (state: State) => state.publicProfile?.name || '',
  ),
  publicProfilePhoto: payloadComputedProperty(
    SB.string(),
    (state: State) => state.publicProfile?.photo || '',
  ),
  paidGems: payloadComputedProperty(
    SB.number(),
    (state: State) => state.inventory.premium.paid,
  ),

  profileAvatarFrame: payloadComputedProperty(SB.string(), (state: State) =>
    getPlayerProfileAvatarFrame(state),
  ),
};
